import { Quote } from "lucide-react";
import Reveal from "./Reveal";

/**
 * Pull-quote block — light or dark variant.
 */
export default function PullQuote({ text, attribution, tone = "light" }) {
  const dark = tone === "dark";
  return (
    <section className={`relative ${dark ? "" : "bg-white"} py-14 md:py-20`} style={dark ? { background: "var(--navy-deep)" } : undefined}>
      {dark && <div className="mandala-bg" style={{ opacity: 0.3 }} />}
      <div className="relative max-w-[900px] mx-auto px-5 md:px-10 text-center">
        <Reveal>
          <Quote size={34} className="text-[var(--gold)] mx-auto opacity-80" strokeWidth={1.2} />
          <blockquote className={`serif-italic text-[22px] md:text-[34px] leading-[1.35] mt-5 ${dark ? "text-white" : "text-[var(--ink)]"}`}>
            “{text}”
          </blockquote>
          {attribution && (
            <div className={`mt-5 text-[11px] tracking-[0.32em] uppercase ${dark ? "text-[var(--gold-light)]" : "text-[var(--gold)]"}`}>
              — {attribution}
            </div>
          )}
        </Reveal>
      </div>
    </section>
  );
}
